import Model from '@/models/Model.js';

export default class DiscussionThreadActivity extends Model {
    static entity = 'discussion_thread_activities';

    static modelName = 'DiscussionThreadActivity';

    static fields() {
        return {
            id: this.attr(null),
            content_template_id: this.attr(null),
            content: this.attr(null),
            min_threads: this.attr(null),
            max_threads: this.attr(null),
            min_replies: this.attr(null),
            thread_min_words: this.attr(null),
            reply_min_words: this.attr(null),
            can_post_threads_after_grade: this.attr(null),
            restrict_until_week_start: this.attr(null),
            closed_at: this.attr(null),

            // These come from the response for DueDateWidgetResource
            completed: this.attr(null),
            marked_complete: this.attr(null),
            threads: this.attr(null),
            replies: this.attr(null),
            parent_week_available: this.attr(null),
            parent_week_start_at: this.attr(null),
            restricted_until_week_start_active: this.attr(null),

            ...super.fields(),
        };
    }
}
